import { get } from 'lodash'

import { joinURLPath } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'
import { isUUID } from '@sigmasms/commons'

import { macroCacheOptions, permissionPresets, request } from '@/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)
const cachedGet = Cache.wrapWithCache(async (key, service, id) => {
  return await request.get(joinURLPath(service, id))
})

export default {
  name: 'LinkService',

  props: {
    value: {
      type: [ String, Object ],
      default: () => {
        return undefined
      }
    },

    params: {
      type: Object,
      default: () => {
        return {}
      }
    },

    service: {
      type: String,
      default: 'users'
    },

    pathToId: {
      type: String,
      default: 'id'
    },
    pathToTitle: {
      type: String,
      default: 'title'
    }
  },

  data() {
    return {
      data: undefined,
      loading: false
    }
  },

  computed: {
    $title() {
      return get(this.data, this.pathToTitle)
    },

    $to() {
      if (this.service && this.data) {
        const id = get(this.data, this.pathToId)
        if (id) {
          return {
            name: `${this.service}.single`,
            params: { id }
          }
        }
      }
    },

    $component() {
      if (this.permissionCheck) {
        return 'router-link'
      }

      return 'div'
    },

    permissionCheck() {
      let accept = permissionPresets.resellerUp
      switch (this.service) {
        case 'contacts':
        case 'contactLists':
        case 'sendernames':
        case 'patterns':
        case 'templates':
        case 'apisender': {
          accept = permissionPresets.meUp
          break
        }
      }

      return this.checkPermissions(`advanced.${this.service}.get`, accept)
    }
  },

  watch: {
    value: {
      handler() {
        this.get()
      },
      deep: true
    }
  },

  mounted() {
    this.get()
  },

  methods: {
    /**
     * Загружает запись сервиса по идентификатору из свойства value.
     *
     * Если value является объектом, он используется как запись без запроса.
     *
     * Ошибка запроса подавляется намеренно: компонент только подписывает
     * ссылку, его отказ не мешает работе страницы, а на списке записей
     * показ ошибки даёт серию одинаковых сообщений. Признак загрузки
     * снимается в любом случае.
     */
    async get() {
      try {
        if (this.value) {
          if (isUUID(this.value)) {
            if (this.permissionCheck) {
              this.loading = true
              const data = await cachedGet(`${this.service}:${this.value}`, this.service, this.value)
              if (data) {
                this.data = data
              }
            }
          } else if (typeof this.value === 'object') {
            this.data = this.value
          }
        }
      } catch {
      } finally {
        this.loading = false
      }
    }
  },

  render
}
